<template>
  <div>
    <BaseTitle :title="$t('content.anal_class')" />
    <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
    <div id="hanyainisaja">
      <!-- Student Ranking -->
      <v-card class="pa-8 mb-4">
        <div class="d-flex align-center justify-space-between">
          <div class="app-section-title mb-5">
            {{ $t('content.student_ranking') }}
            <br />
          </div>

          <v-btn color="primary" class="btn-primary-custom mr-3" :loading="loadingExport" @click="downloadPdf()">Export PDF</v-btn>
        </div>
        <div class="mt-2 mb-8">
          <strong style="color: #6d6d6d;">{{ $t('menu.class') }}</strong>
          <span class="mt-2 d-block"> {{ dataClass.classroomName }} </span>
        </div>
        <div class="d-flex justify-space-between mb-5">
          <strong style="color: #6d6d6d;"> {{ $t('content.list_student') }}</strong>
          <strong style="color: #00bf63;"> {{ dataClass.students.length ? dataClass.students.length : 0 }} {{ $t('content.student') }}</strong>
        </div>
        <v-data-table :headers="tableHeaderStudent" :loading="loadingLoad" :items="dataClass.students" hide-default-footer class="table-custom">
          <template #item.serialNo="{item}">
            <td>
              {{ dataClass.students.indexOf(item) + 1 }}
            </td>
          </template>
          <template #no-data> <NoData /></template>
        </v-data-table>
      </v-card>
      <!-- Courses Average Score -->
      <v-card class="pa-8 mb-4">
        <div class="d-flex align-center justify-space-between">
          <div class="app-section-title mb-5">
            {{ $t('content.course_average_score') }}
            <br />
          </div>
        </div>
        <v-divider />
        <div class="d-flex flex-row-reverse mt-5 mb-5">
          <div class="app-section-title " style="color:#00bf63;">{{ dataClass.course.averageScore }} %</div>
        </div>
        <div id="chart" class="d-flex justify-center">
          <apexchart type="line" height="350" width="600" :options="chartOptionsClassPerform" :series="seriesClassPerform" />
        </div>
      </v-card>

      <!-- Course Score Detail -->
      <v-card class="pa-8 mb-4">
        <div class="d-flex align-center justify-space-between">
          <div class="app-section-title mb-5">
            {{ $t('content.course_score_detail') }}
            <br />
          </div>
        </div>
        <v-divider class="mt-5 mb-2" />
        <v-row class="mb-5">
          <v-col md="7" class="mt-4 d-flex d-inline">
            <div v-for="(data, index) in ListCourseScore" :key="index" class="mr-4">
              <v-chip
                :color="
                  index === 0
                    ? '#0177FB'
                    : index === 1
                    ? '#40DCA7'
                    : index === 2
                    ? '#FF9743'
                    : index === 3
                    ? 'rgb(255, 69, 96)'
                    : index === 4
                    ? 'rgb(119, 93, 208)'
                    : 'black'
                "
                dark
              >
                {{ data.courseName }}
              </v-chip>
            </div>
          </v-col>
          <v-col md="5">
            <div>
              <form-group :name="$t('form.course_choose_detail')" no-gutter>
                <template slot-scope="{ attrs }">
                  <v-select
                    v-bind="attrs"
                    v-model="courseIds"
                    item-value="courseId"
                    item-text="name"
                    :items="listCourse"
                    @change="getListCourseScore()"
                    :label="$t('form.course_choose_detail')"
                    persistent-hint
                    multiple
                    chips
                  />
                </template>
              </form-group>
            </div>
          </v-col>
          <div class="attendance-scroller pa-6">
            <table class="attendance-table">
              <thead>
                <tr>
                  <th width="250" class="attendance-sticky">
                    <div>{{ $t('form.course') }}</div>
                  </th>
                  <th width="280" v-for="(item, index) in ListCourseScore" :key="index">
                    <div>
                      <div class="d-flex flex-row justify-start">
                        <div class="flex-grow-1">
                          {{ item.courseName }}
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, indexParent) in assignmentCount" :key="indexParent">
                  <td class="attendance-sticky">
                    <div class="d-flex align-center" style="height:40px">
                      <strong> Assignment {{ indexParent + 1 }} </strong>
                    </div>
                  </td>
                  <td class="attendance-sticky" valign="middle" v-for="(item, index) in ListCourseScore" :key="index">
                    <span>
                      {{ item.assignments[indexParent] ? item.assignments[indexParent].score : '-' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-row>
      </v-card>
      <!-- Inter-class Comparison -->
      <v-card class="pa-8">
        <div class="d-flex align-center justify-space-between">
          <div class="app-section-title mb-5">
            {{ $t('content.class_inter_comparison') }}
            <br />
          </div>
        </div>
        <v-divider class="mt-5 mb-2" />
        <v-row class="mb-5">
          <v-col md="8" class="mt-4 d-flex d-inline">
            <div v-for="(data, index) in seriesInterclass" :key="index" class="mr-4">
              <v-chip
                :color="
                  index === 0
                    ? '#0177FB'
                    : index === 1
                    ? '#40DCA7'
                    : index === 2
                    ? '#FF9743'
                    : index === 3
                    ? 'rgb(255, 69, 96)'
                    : index === 4
                    ? 'rgb(119, 93, 208)'
                    : 'black'
                "
                dark
              >
                {{ data.name }}
              </v-chip>
            </div>
          </v-col>
          <v-col md="4">
            <div>
              <form-group :name="$t('form.class_compare_add')" no-gutter>
                <template slot-scope="{ attrs }">
                  <v-select
                    v-bind="attrs"
                    v-model="classroomIds"
                    item-value="classroomId"
                    item-text="name"
                    clearable
                    :items="listClassInter"
                    @change="getDataInterClass"
                    :label="$t('form.class_compare_add')"
                    persistent-hint
                    multiple
                    chips
                  />
                </template>
              </form-group>
            </div>
          </v-col>
        </v-row>
        <div id="chart">
          <apexchart type="bar" height="350" :options="chartOptionsInterClass" :series="seriesInterclass"></apexchart>
        </div>
      </v-card>
    </div>
    <!-- export content -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      filename="agung"
      :paginate-elements-by-height="1100"
      :pdf-quality="2"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :manual-pagination="false"
      :html-to-pdf-options="htmlToPdfOptions"
      @beforeDownload="beforeDownload($event)"
      ref="html2Pdf"
    >
      <section class="pdf-content table-content" slot="pdf-content">
        <!-- Student rank -->
        <section class="table-container">
          <table border="0" width="100%">
            <tr>
              <td>
                Nama Sekolah :<span style="color :#6D6D6D;"> {{ dataClass.schoolName ? dataClass.schoolName : '-' }} </span>
              </td>
              <td>
                Kelas : <span style="color :#6D6D6D;"> {{ dataClass.classroomName ? dataClass.classroomName : '-' }}</span>
              </td>
            </tr>
            <br />
            <tr>
              <td>
                Teacher : <span style="color :#6D6D6D;"> {{ dataClass.teachers.length ? dataClass.teachers.toString() : '-' }}</span>
              </td>
              <td>
                Tahun Ajaran : <span style="color :#6D6D6D;"> {{ dataClass.yearPeriode ? dataClass.yearPeriode : '-' }}</span>
              </td>
            </tr>
          </table>
        </section>
        <section class="line">
          <hr width="100%" />
        </section>
        <section
          class="line"
          style="
          margin-top:20px;
          margin-bottom:40px;
          text-align: center"
        >
          <span style="color :#6D6D6D; font-size:20px;">Analytical Class</span>
        </section>

        <section class="chart-container" style="padding:40px;">
          <div class="row">
            <div class="left">
              <strong style="color: #6d6d6d;">A. Student Rank</strong>
            </div>
            <div class="right">
              <span style="color: #6d6d6d;">
                Total Student :
                <strong style="color: #00bf63;"> {{ dataClass.students.length ? dataClass.students.length : 0 }} Student</strong>
              </span>
            </div>
          </div>
          <v-data-table :headers="tableHeaderStudent" :loading="loadingLoad" :items="dataClass.students" hide-default-footer class="table-custom">
            <template #item.serialNo="{item}">
              <span style="margin-left:40px;">
                {{ dataClass.students.indexOf(item) + 1 }}
              </span>
            </template>
            <template #item.fullName="{item}">
              <span style="margin-left:150px;">
                {{ item.fullName }}
              </span>
            </template>
            <template #item.rank="{item}">
              <span style="margin-left:60px;">
                {{ item.rank }}
              </span>
            </template>
            <template #no-data> <NoData /></template>
          </v-data-table>
        </section>

        <div class="html2pdf__page-break" />

        <!-- course score average -->
        <section class="table-container" style="padding:40px;">
          <table border="0" width="100%">
            <tr>
              <td>
                Nama Sekolah :<span style="color :#6D6D6D;"> {{ dataClass.schoolName ? dataClass.schoolName : '-' }} </span>
              </td>
              <td>
                Kelas : <span style="color :#6D6D6D;"> {{ dataClass.classroomName ? dataClass.classroomName : '-' }}</span>
              </td>
            </tr>
            <br />
            <tr>
              <td>
                Tahun Ajaran : <span style="color :#6D6D6D;"> {{ dataClass.yearPeriode ? dataClass.yearPeriode : '-' }}</span>
              </td>
            </tr>
          </table>
        </section>
        <section class="line">
          <hr width="100%" style="margin-bottom:50px;" />
        </section>
        <section class="chart-container" style="padding:40px;">
          <div class="row">
            <div class="left">
              <strong style="color: #6d6d6d;">B. Course Average Score</strong>
            </div>
            <div class="right">
              <div class="app-section-title " style="color:#00bf63;">{{ dataClass.course.averageScore }} %</div>
              Grade
            </div>
          </div>
          <apexchart type="line" height="110%" width="100%" :options="chartOptionsClassPerform" :series="seriesClassPerform" />
        </section>
        <div class="html2pdf__page-break" />

        <!-- Course Score Detail -->
        <section class="table-container">
          <table border="0" width="100%">
            <tr>
              <td>
                Nama Sekolah :<span style="color :#6D6D6D;"> {{ dataClass.schoolName ? dataClass.schoolName : '-' }} </span>
              </td>
              <td>
                Kelas : <span style="color :#6D6D6D;"> {{ dataClass.classroomName ? dataClass.classroomName : '-' }}</span>
              </td>
            </tr>
            <br />
            <tr>
              <td>
                Tahun Ajaran : <span style="color :#6D6D6D;"> {{ dataClass.yearPeriode ? dataClass.yearPeriode : '-' }}</span>
              </td>
            </tr>
          </table>
        </section>
        <section class="line">
          <hr width="100%" style="margin-bottom:50px;" />
        </section>
        <section class="line">
          <div class="row">
            <div class="left">
              <strong style="color: #6d6d6d;">C.Course Score Detail</strong>
            </div>
          </div>
          <div class="pa-6">
            <table class="attendance-table-export">
              <thead>
                <tr>
                  <th width="250" class="attendance-sticky">
                    <div style="color: #ffffff">Course</div>
                  </th>
                  <th width="280" v-for="(item, index) in ListCourseScore" :key="index">
                    <div>
                      <div class="d-flex flex-row justify-start">
                        <div class="flex-grow-1" style="color: #ffffff">
                          {{ item.courseName }}
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, indexParent) in assignmentCount" :key="indexParent">
                  <td class="attendance-sticky">
                    <div class="d-flex align-center" style="height:40px">
                      <strong> Assignment {{ indexParent + 1 }} </strong>
                    </div>
                  </td>
                  <td class="attendance-sticky" valign="middle" v-for="(item, index) in ListCourseScore" :key="index">
                    <span>
                      {{ item.assignments[indexParent] ? item.assignments[indexParent].score : '-' }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </section>
    </vue-html2pdf>
    <div class="d-flex justify-end align-center mt-5">
      <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('back') }}</v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import apexchart from 'vue-apexcharts';
import FileViewer from '@/components/FileViewerErapor';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  name: 'ViewClassDetail',
  components: {
    BaseTitle,
    NoData,
    apexchart,
    FileViewer,
    VueHtml2pdf
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateDetailAnalyticalClass({ schoolId, analyticalClassId }) {
      const currentschoolId = this.user.schoolId;
      const currentanalyticalClassId = this.$route.params.idClass;
      if (schoolId == currentschoolId && analyticalClassId == currentanalyticalClassId) {
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update Analytic Class Detail' });
        setTimeout(() => {
          this.getData();
          this.getDataClass();
        }, 400);
      }
    }
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    tableHeaderStudent() {
      return [
        { text: 'No', value: 'serialNo' },
        { text: this.$t('content.student_name'), value: 'fullName' },
        { text: this.$t('content.student_ranking'), value: 'rank' }
      ];
    },
    htmlToPdfOptions() {
      return {
        margin: 0,

        filename: 'pusing.pdf',

        image: {
          type: 'jpeg',
          quality: 0.98
        },

        enableLinks: true,

        html2canvas: {
          scale: 2,
          useCORS: true
        },

        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        }
      };
    }
  },
  data: () => ({
    loadingLoad: false,
    loadingExport: false,
    dataClass: {
      classroomName: '',
      schoolName: '',
      yearPeriode: '',
      students: [],
      teachers: [],
      course: {
        averageScore: '',
        categories: [],
        data: []
      }
    },
    seriesClassPerform: [],
    chartOptionsClassPerform: {},
    seriesInterclass: [],
    chartOptionsInterClass: {},
    listClassInter: [],
    ListCourseScore: [],
    classroomIds: [],
    courseIds: [],
    listCourse: [],
    assignmentCount: 0,
    classroomId: '',
    dialogPreview: false,
    preview: {}
  }),
  methods: {
    async downloadPdf() {
      this.$refs.html2Pdf.generatePdf();
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      this.loadingExport = true;
      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then(pdf => {
          var blobURL = window.URL.createObjectURL(new Blob([pdf.output('blob')], { type: 'application/pdf' }));
          const fileList = {
            URL: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            extension: 'pdf',
            fileName: `analytical class`,
            fileUrl: blobURL,
            key: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
            name: `analytical class.pdf`,
            size: '186 KB',
            dataUpload: pdf.output('blob')
          };
          this.dialogPreview = true;
          this.$set(this, 'preview', fileList);

          this.loadingExport = false;
        });
    },
    download() {
      this.loadingExport = true;
      html2canvas(document.querySelector('#hanyainisaja'), { useCORS: true }).then(canvas => {
        // let img = canvas.toDataURL('image/png');

        const imgData = canvas.toDataURL('image/png');
        var imgWidth = 200;
        var pageHeight = 287;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;

        var doc = new jsPDF('p', 'mm');
        var position = 5;

        doc.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight + 15);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(imgData, 'PNG', 5, position, imgWidth, imgHeight + 15);
          heightLeft -= pageHeight;
        }

        // pdf.addImage(img, 'JPEG', 5, 5, 200, 287);

        var blob = doc.output('blob');
        var blobURL = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
        const fileList = {
          URL: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
          extension: 'pdf',
          fileName: `analytical class`,
          fileUrl: blobURL,
          key: 'school-3/user-12/69123669-97be-4565-87e2-7555e103587e_202106281607.pdf',
          name: `analytical class.pdf`,
          size: '186 KB',
          dataUpload: blob
        };
        this.dialogPreview = true;
        this.$set(this, 'preview', fileList);

        this.loadingExport = false;
      });
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Analytical/getListClassByID', this.$route.params.idClass)
        .then(res => {
          this.classroomId = res.classroomId;
          this.getListCourseScore(res.classroomId);
          // class perform chart
          let seriesClassPerform = [
            {
              name: 'Average',
              data: res.course.data
            }
          ];
          let optionsClassPerform = {
            chart: {
              height: 350,
              type: 'line'
            },
            stroke: {
              width: 7,
              curve: 'smooth'
            },
            xaxis: {
              categories: res.course.categories,
              tickAmount: 10
            },
            fill: {
              type: 'gradient',
              gradient: {
                shade: 'dark',
                gradientToColors: ['#FDD835'],
                shadeIntensity: 1,
                type: 'horizontal',
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100, 100, 100]
              }
            },
            markers: {
              size: 4,
              colors: ['#FFA41B'],
              strokeColors: '#fff',
              strokeWidth: 2,
              hover: {
                size: 7
              }
            },
            yaxis: {
              min: 0
            }
          };

          this.chartOptionsClassPerform = optionsClassPerform;
          this.seriesClassPerform = seriesClassPerform;

          this.dataClass = res;
        })
        .finally(() => (this.loadingLoad = false));
    },
    getDataInterClass() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Analytical/getListClassComprasByID', { id: this.$route.params.idClass, classId: this.classroomIds })
        .then(res => {
          // inter-class comprasion

          let seriesInterclass = res.series;
          let chartOptionsInterClass = {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '15%',
                endingShape: 'rounded'
              }
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: res.categories
            },
            yaxis: {
              min: 0
            },
            fill: {
              opacity: 1
            }
          };
          this.seriesInterclass = seriesInterclass;
          this.chartOptionsInterClass = chartOptionsInterClass;
        })
        .finally(() => (this.loadingLoad = false));
    },
    getListClassroomInterClass() {
      this.loadingLoad = true;
      this.$store
        .dispatch(`Analytical/getListInterClass`, this.$route.params.idClass)
        .then(data => {
          this.listClassInter = data;
        })
        .finally(() => (this.loadingLoad = false));
    },
    getListCourseScore(id) {
      if (id) {
        const payload = { id: id, classid: id };
        this.loadingLoad = true;
        this.$store
          .dispatch('CourseList/fetchList', payload)
          .then(data => {
            let datas = data.reduce((acc, row) => {
              acc.push(row.courseId);
              return acc;
            }, []);
            this.courseIds = datas;
            this.listCourse = data;
          })
          .finally(() => {
            this.loadingLoad = false;
          });
      }

      if (!this.courseIds.length) {
        let datas = this.listCourse.reduce((acc, row) => {
          acc.push(row.courseId);
          return acc;
        }, []);

        this.courseIds = datas;
      }

      this.loadingLoad = true;
      this.$store
        .dispatch(`Analytical/getListCourseScore`, { id: this.$route.params.idClass, courseId: this.courseIds })
        .then(data => {
          this.assignmentCount = data.reduce((acc, item) => (acc = acc > item.assignmentCount ? acc : item.assignmentCount), 0);
          this.ListCourseScore = data;
        })
        .finally(() => (this.loadingLoad = false));
    },
    exportPDF() {
      console.log('test');
    },
    back() {
      this.$router.push({ name: 'AnalyticClassList' });
    }
  },
  created() {
    this.getData();
    this.getDataInterClass();
    this.getListClassroomInterClass();
    // this.getListCourseScore();
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}
.attendance-scroller {
  overflow-x: scroll;
  overflow-y: visible;
}
.attendance-table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th {
    padding: 10px;
    text-align: left;
    color: #fff;
  }

  td {
    padding: 0px 13px;
    height: 50px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: #fff;

    &:not(.attendance-sticky) {
      font-weight: bold;

      &:hover {
        background: #f8f8f8;
      }
    }
  }

  thead {
    tr {
      th {
        $height: 50px;
        height: 50px;
        background: #00bf63;

        div {
          height: 50%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          button {
            position: absolute;
            top: -5px;
            right: 0;
          }
        }
      }
    }
  }
}
.attendance-table-export {
  border-collapse: collapse;
  width: 100%;

  th {
    padding: 10px;
    text-align: left;
    color: #fff;
  }

  td {
    padding: 0px 13px;
    height: 50px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: #fff;

    &:not(.attendance-sticky) {
      font-weight: bold;

      &:hover {
        background: #f8f8f8;
      }
    }
  }

  thead {
    tr {
      th {
        $height: 50px;
        height: 50px;
        background: #00bf63;

        div {
          height: 50%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          button {
            position: absolute;
            top: -5px;
            right: 0;
          }
        }
      }
    }
  }
}
.pdf-content {
  width: 100%;
  background: #fff;
  div {
    color: #6d6d6d;
  }

  .chart-container {
    width: 100%;
    height: 320px;
    padding: 20px;
    pointer-events: none;
  }
  .line {
    color: #6d6d6d;
    -webkit-print-color-adjust: exact;
    width: 100%;
    margin-top: 15px;
    padding: 0px 40px 0px 40px;
    pointer-events: none;
  }
  .table-container {
    -webkit-print-color-adjust: exact;
    width: 100%;
    padding: 20px 20px 20px 40px;
    pointer-events: none;
  }
}
.row {
  display: flex;
  align-items: center;
}
.left {
  margin-left: 50px;
  margin-right: auto;
  margin-bottom: 10px;
}
.right {
  margin-left: auto;
  margin-right: 50px;
  margin-bottom: 10px;
}
</style>
